import Animation from "./Animation";
import { gsap, Sine } from "gsap";

/**
 * This is the animation bound within the Global Mask
 *  - write any sort of site load in animation here
 *
 */
class FixedAddToCart extends Animation {

	// TODO: options overwrite

	animate({ done }) {
		// gsap.to(this.element, { duration: 0.4, autoAlpha: 0, onComplete: done });

		// done();
	}
}

export default FixedAddToCart;
